export const SIDEBAR_WIDTH = {
  DEFAULT: 'w-95',
  LARGE: 'w-120',
} as const;

export interface ContentWithRightSidebarProps {
  content: React.ReactNode;
  sidebar: React.ReactNode;
  sidebarWidth?: (typeof SIDEBAR_WIDTH)[keyof typeof SIDEBAR_WIDTH];
}
